import { Icons, IconsList } from '@mint-lib/icons/allIcons';

import {
  AssetsLoadingState as IconLoadingState,
  useLazyLoadedAssets,
} from './useLazyLoadedAssets.js';

export function useLazyLoadedIcon(name: IconsList) {
  return useLazyLoadedAssets(name, Icons);
}

export { IconLoadingState };
